import Field from '@/ecm/models/document/Field'
export default class DocumentTrackerData {
    constructor(dto, state, fieldsToShow) {
        this.objectId = 0;
        this.state = "OnTime";
        this.fields = [];

        if (dto) {
            this.objectId = dto.ObjectID;
            this.state = state;
            this.fields = dto.Fields.filter(f => fieldsToShow.includes(f.Code)).map(function (f) { return new Field(f, dto.Fields) });
        }
    }
}
